module.exports = __webpack_public_path__ + "img/BACT.4f2e2015.png";